export default {
  blank: '',
  overview: 'Overview'
}
